export default __webpack_public_path__ + "250c36cd94377142675ee4294d5c195f.gif";